export const EFeaturesCategory = {
  BULK_ACTIONS: 'BULK_ACTIONS',
  IMAGE: 'IMAGE',
  DIFFUSION_MODELS: 'DIFFUSION_MODELS',
  SEARCH: 'SEARCH',
  GENERATION: 'GENERATION',
  USER_TASK: 'USER_TASK',
  COLLECTION: 'COLLECTION',
};
